export default {
  SAVE_USER_LOCATIONS: 'userLocations/SAVE_USER_LOCATIONS',
  REMOVE_USER_LOCATION: 'userLocations/REMOVE_USER_LOCATION',
  ACTIVATE_USER_LOCATION: 'userLocations/ACTIVATE_USER_LOCATION',
  SET_PRIMARY_LOCATION: 'userLocations/SET_PRIMARY_LOCATION',
  ADD_LOCATION: 'userLocations/ADD_LOCATION',
  UPDATE_LOCATION: 'userLocations/UPDATE_LOCATION',
};
